"use strict";

define('uikit/modules/input.date',['require','exports','module','underscore','backbone','backbone.radio','marionette','handlebars','moment','../channel','../mixins/component.mixin','./calendar','./popup','../elements/button','../elements/input','../extra/key.codes','templates'],function (require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Radio = require('backbone.radio');
  var Mn = require('marionette');
  var Handlebars = require('handlebars');
  var moment = require('moment');
  var channel = require('../channel');
  var ComponentMixin = require('../mixins/component.mixin');
  var Calendar = require('./calendar');
  var Popup = require('./popup');
  var ButtonView = require('../elements/button');
  var Input = require('../elements/input');
  var CODES = require('../extra/key.codes');
  var Templates = require('templates');
  var AppChannel = Radio.channel('global');
  var DATE_REGEX = /([0-9]*)[\/.\-\s]?([0-9]*)[\/.\-\s]?([0-9]*)/;
  var DateInput = Mn.ItemView.extend(ComponentMixin).extend({
    options: {
      disabled: false,
      readonly: false,
      value: '',
      icon: 'calendar',
      placeholder: '',
      todayButton: false,
      format: 'L'
    },
    update: {
      icon: false,
      value: false,
      format: false,
      todayButton: false,
      readonly: false
    },
    template: Templates.IRB['input.date'],
    events: {
      'click input': function click_input() {
        if (this.getOption('disabled')) {
          return;
        }
        if (!this._buttonWasPressed) {
          this.focus();
        }
        this._buttonWasPressed = false;
      },
      'click .calendar-icon': function click_CalendarIcon() {
        $(this.datePopup.el).css("opacity", "0");
        var that = this;
        if (this.disabled) {
          return;
        }
        var inputName = this.bindings.value;
        $(this.el).find('.calendar-icon').attr('data-name', inputName);
        $(this.datePopup.el).attr('data-name', inputName);
        this.datePopup.visible = true;
        this.datePopup.duration = 0;
        setTimeout(function () {
          var distanceToTop = $(that.el).find('.calendar-icon')[0].getBoundingClientRect().top;
          var calendarButton = $(that.el).find('.calendar-icon');
          var expirationDateCalendar = $('div[data-name="expirationDate');
          if ($(window).height() - distanceToTop - calendarButton.outerHeight() <= expirationDateCalendar.outerHeight()) {
            var noSpace = distanceToTop - ($('.common-header').outerHeight() + $('.product-header').outerHeight() + expirationDateCalendar.outerHeight() + 10) <= 0;
            expirationDateCalendar.removeClass("right left top bottom center");
            expirationDateCalendar.addClass(noSpace ? "right center" : "top left");
            expirationDateCalendar.css("inset", noSpace ? "0px auto auto " + (calendarButton[0].offsetLeft + 35) + "px" : "auto auto 207px auto");
          }
          $(that.datePopup.el).css("opacity", "1");
        }, 100);
        setTimeout(function () {
          var activeCell = $(that.datePopup.el).find('.day.cell.active')[0];
          var todayCell = $(that.datePopup.el).find('.day.cell.today')[0];
          var firstCell = $(that.datePopup.el).find('.day.cell')[0];
          if (activeCell) {
            activeCell.focus();
          } else if (todayCell) {
            todayCell.focus();
          } else if (firstCell) {
            firstCell.focus();
          }
        }, 300);
      }
    },
    internalViewOptions: function internalViewOptions() {
      return {
        input: {
          disabled: this.getBoolOption('disabled'),
          icon: this.getOption('icon'),
          placeholder: AppChannel.request('get:placeholder:locale'),
          readonly: this.getBoolOption('readonly')
        }
      };
    },
    initialize: function initialize() {
      ComponentMixin.initialize.apply(this, arguments);
      this.input.button = new ButtonView({
        visible: false,
        text: 'Today',
        basic: true,
        compact: true
      });
      this.onChangeTodayButton();
      var calendar = new Calendar({
          selectable: true,
          aligned: 'center'
        }),
        datePopup = new Popup({
          showOn: 'manual',
          width: Popup.WIDE,
          position: 'bottom left',
          content: calendar,
          compact: true,
          borderless: true
        }).attach(this),
        self = this;
      calendar.$el.css('width', '295px');
      calendar.controls.fluid = true;
      calendar.controls.text.disabled = true;
      this.calendar = calendar;
      this.datePopup = datePopup;
      $(this.el).find('.calendar-icon').attr('aria-disabled', this.disabled);
      function onDocumentMouseDown(ev) {
        self._clicky = $(ev.target);
        if ($('.ui.popup.visible').find(ev.target).length === 0) {
          self.datePopup.visible = false;
          setTimeout(function () {
            if (self.input && !self.input.value) {
              self.calendar.month = moment().month();
              self.calendar.year = moment().year();
            }
          }, 100);
        }
      }
      function onDocumentMouseUp() {
        self._clicky = null;
      }
      $(document).mousedown(onDocumentMouseDown).mouseup(onDocumentMouseUp);
      this.on('destroy', function () {
        $(document).off('mousedown', onDocumentMouseDown).off('mouseup', onDocumentMouseUp);
        calendar.destroy();
        datePopup.destroy();
      }).listenTo(calendar, 'change:value', this.onChangeCalendarValue).listenTo(this.input.button, 'press', this.onButtonPress).listenTo(this.input, 'change:value', this.onChangeInputValue).listenTo(this.input, 'before:key:code', this.onKeyCode).listenTo(this.input, 'enter', this.onEnter).listenTo(this.input, 'escape', this.onEscape).listenTo(this.input, 'blur', this.onBlur).listenTo(this.vent, 'change:value', function () {
        this.input.value = this.value ? moment(this.value).format(this.format) : '';
      });
    },
    onChangeTodayButton: function onChangeTodayButton() {
      this.input.button.visible = this.todayButton;
    },
    focus: function focus() {
      this.input.focus();
      return this;
    },
    blur: function blur() {
      this.input.blur();
      return this;
    },
    onButtonPress: function onButtonPress() {
      this._buttonWasPressed = true;
      if (this.todayButton) {
        this.value = +moment();
      }
    },
    _syncDateValue: function _syncDateValue() {
      var value = this.calendar.value;
      this.value = value ? +moment(value).startOf('day') : null;
      this.vent.trigger('change:value');
    },
    updateCalendar: function updateCalendar() {
      var value = String(this.input.value || '').replace(/-/g, '/');
      var date = null;
      if (value) {
        var localeLongDateFormat = AppChannel.request('get:moment:longdateformat', 'L');
        var isDayMonthFormat = localeLongDateFormat.charAt(0).toLowerCase() === 'd';
        var dayIndex = isDayMonthFormat ? 1 : 2;
        var monthIndex = isDayMonthFormat ? 2 : 1;
        var match = value.match(DATE_REGEX);
        var month = match[monthIndex] - 1 || moment().month();
        var day = match[dayIndex] || moment().date();
        var year = match[3] || moment().year();
        if (match[monthIndex] === '1' || match[monthIndex] === '01') {
          month = '0';
        }
        date = moment({
          year: year,
          month: month,
          day: day
        });
      }
      this.calendar.value = date && date.isValid() ? date : null;
      this.calendar.year = date && date.isValid() ? date.year() : moment().year();
      this.calendar.month = date && date.isValid() ? date.month() : moment().month();
      return date;
    },
    onChangeInputValue: function onChangeInputValue() {
      var date = this.updateCalendar();
      this._internal.value = date && date.isValid() ? +moment(date) : null;
    },
    onChangeCalendarValue: function onChangeCalendarValue() {
      var self = this;
      if (!this._userDidTypeValue) {
        this._syncDateValue();
        this.datePopup.visible = false;
      }
      this._userDidTypeValue = false;
    },
    onEnter: function onEnter() {
      this._syncDateValue();
      this.datePopup.visible = false;
    },
    onEscape: function onEscape() {
      this._syncDateValue();
      this.datePopup.visible = false;
    },
    onKeyCode: function onKeyCode(code) {
      if (code !== CODES.TAB_KEY && code !== CODES.ENTER_KEY && code !== CODES.ESCAPE_KEY) {
        if (code !== CODES.BACKSPACE_KEY || !!this.value) {
          this._userDidTypeValue = true;
        }
      }
    },
    onBlur: function onBlur() {
      var self = this;
      if (this._clicky && (this._clicky.get(0) === this.datePopup.$el.get(0) || $.contains(this.datePopup.$el.get(0), this._clicky.get(0)))) {
        _.defer(function () {
          self.focus();
        });
      } else {
        this._syncDateValue();
      }
    },
    onChangePlaceholder: function onChangePlaceholder() {
      this.input.placeholder = this.placeholder;
    },
    onChangeIcon: function onChangeIcon() {
      this.input.icon = this.icon;
    },
    onChangeReadonly: function onChangeReadonly() {
      this.input.readonly = this.getBoolOption('readonly');
    },
    onChangeDisabled: function onChangeDisabled() {
      var self = this;
      this.input.disabled = this.disabled;
      setTimeout(function () {
        $(self.el).find('.calendar-icon').attr('aria-disabled', self.disabled);
      }, 50);
    },
    onChangeVisible: function onChangeVisible() {
      if (!this.visible) {
        this.datePopup.visible = false;
      }
    }
  });
  channel.reply('input-date', function () {
    return DateInput;
  });
  module.exports = DateInput;
});

